<template>
    <div class="instructions" :class="{ hideIntructionsMobile: hideIntructionsMobile }">
        <div class="titles-container" v-if="type === 'register'">
            <h1>{{ $t('register.instructionstitle1') }}</h1>
            <h1>{{ $t('register.instructionstitle2') }}</h1>
            <h1>{{ $t('register.instructionstitle3') }}</h1>
        </div>
        <div class="titles-container" v-if="type === 'login_ib_portal' || type === 'login'">
            <h1>{{ $t('register.instructionsIBportal1') }}</h1>
            <h1>{{ $t('register.instructionsIBportal2') }}</h1>
            <h1>{{ $t('register.instructionsIBportal3') }}</h1>
        </div>
        <div class="options-container">
            <div class="option">
                <div class="option-image">
                    <img src="/assets/images/login-img-1.svg" alt="login-img-1" v-if="type === 'login'" />
                    <img src="/assets/images/login-option-1.svg" alt="login-option-1.svg" v-if="type === 'register'" />
                    <img src="/assets/images/login-option_ib1.svg" alt="login-option-1.svg" v-if="type === 'login_ib_portal'" />
                </div>
                <div class="option-label" v-if="type === 'register'">
                    <p>
                        {{ $t('register.options1f') }}<br />
                        {{ $t('register.options1l') }}
                    </p>
                </div>
                <div class="option-label" v-if="type === 'login'">
                    <p>
                        {{ $t('loginPage.options1f') }}<br />
                        {{ $t('loginPage.options1l') }}
                    </p>
                </div>
                <div class="option-label" v-if="type === 'login_ib_portal'">
                    <p>
                        {{ $t('register.options1f_ib_portal') }}<br />
                        {{ $t('register.options1l_ib_portal') }}
                    </p>
                </div>
            </div>
            <div class="option">
                <div class="option-image">
                    <img src="/assets/images/login-img-2.svg" alt="login-img-2"  v-if="type === 'login'" />
                    <img src="/assets/images/login-option-2.svg" alt="login-option-2.svg" v-if="type === 'register'" />
                    <img src="/assets/images/login-option-2.svg" alt="login-option-2.svg" v-if="type === 'login_ib_portal'" />
                </div>
                <div class="option-label" v-if="type === 'register'">
                    <p>
                        {{ $t('register.options2f') }} <br />{{
                            $t('register.options2l')
                        }}
                    </p>
                </div>
                <div class="option-label" v-if="type === 'login'">
                    <p>
                        {{ $t('loginPage.options2f') }}<br />
                        {{ $t('loginPage.options2l') }}
                    </p>
                </div>
                <div class="option-label" v-if="type === 'login_ib_portal'">
                    <p>
                        {{ $t('register.options2f_ib_portal') }} <br />{{
                            $t('register.options2l_ib_portal')
                        }}
                    </p>
                </div>
            </div>
            <div class="option">
                <div class="option-image">
                    <img src="/assets/images/login-img-3.svg" alt="login-img-3.svg" v-if="type === 'login'" />
                    <img src="/assets/images/login-option-3.svg" alt="login-option-3.svg" v-if="type === 'register'" />
                    <img src="/assets/images/login-option_ib3.svg" alt="login-option-1.svg" v-if="type === 'login_ib_portal'" />
                </div>
                <div class="option-label" v-if="type === 'register'">
                    <p>
                        {{ $t('register.options3f') }}<br />{{
                            $t('register.options3l')
                        }}
                    </p>
                </div>
                <div class="option-label" v-if="type === 'login'">
                    <p>
                        {{ $t('loginPage.options3f') }}<br />
                        {{ $t('loginPage.options3l') }}
                    </p>
                </div>
                <div class="option-label" v-if="type === 'login_ib_portal'">
                    <p>
                        {{ $t('register.options3f_ib_portal') }}<br />{{
                            $t('register.options3l_ib_portal')
                        }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
	name: 'Intructions',
    props: {
        hideIntructionsMobile: Boolean,
        type:String
    }
}
</script>
